import React from 'react';
import styles from './sede.module.css';

const Sede = ({ citta, x, y, onMouseEnter, onFocus }) => {
  return (
    <text
      fill="#FFF"
      className={`${styles.textSVG} text-center snf-font-15`}
      transform="translate(-338 -112) translate(338 112) translate(.2 .4)"
      style={{ cursor: 'pointer' }}
      onMouseEnter={onMouseEnter}
      onFocus={onFocus}
      tabIndex="0"
    >
      <tspan x={x} y={y} className="font-weight-bold text-uppercase">
        {citta}
      </tspan>
    </text>
  );
};

Sede.displayName = 'Sede';
export { Sede };
